(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dumbbell-rack-configurator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dumbbell-rack-configurator')) {
    customElements.define('dumbbell-rack-configurator', class extends HTMLElement {
      connectedCallback() {
        this.product = JSON.parse(this.querySelector('[data-product-json]').textContent);
        this.form = this.querySelector('form');
        this.variantInput = this.querySelector('[data-variant-id]');
        this.submitButton = this.querySelector('[data-configurator-submit]');
        this.acceleratedCheckout = this.querySelector('[data-accelerated-checkout]');
        this.validation = this.querySelector('[data-configurator-validation]');
        this.numberList = this.querySelector('[data-number-list]');
        this.emptyState = this.querySelector('[data-empty-state]');
        this.setOverview = this.querySelector('[data-set-overview]');
        this.editorToggle = this.querySelector('[data-editor-toggle]');
        this.numberEditor = this.querySelector('[data-number-editor]');
        this.numberEditorHeading = this.querySelector('[data-number-editor-heading]');
        this.limitMessage = this.querySelector('[data-limit-message]');
        this.pricingStatus = this.querySelector('[data-pricing-status]');
        this.artworkSection = this.querySelector('[data-artwork-section]');
        this.artworkUploadTarget = this.querySelector('[data-artwork-upload-target]');
        this.purchaseActions = this.querySelector('[data-purchase-actions]');
        this.stylePosition = Number(this.dataset.stylePosition);
        this.countPosition = Number(this.dataset.countPosition);
        this.maxStickers = Number(this.dataset.maxStickers);
        this.optionMappingValid = this.dataset.optionMappingValid === 'true';
        this.numbers = new Map();
        this.startingSet = '5–50';
        this.pendingStartingSet = null;
        this.pristineSignature = '';
        this.currentVariant = null;
        this.editorExpanded = false;

        this.bindEvents();
        this.applyStartingSet(this.startingSet);
        this.relocateUploadKit();
        this.uploadKitObserver = new MutationObserver(() => this.relocateUploadKit());
        this.uploadKitObserver.observe(this.form, { childList: true, subtree: true });
      }

      disconnectedCallback() { this.uploadKitObserver?.disconnect(); }

      bindEvents() {
        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-style-option]')) this.render();
          if (event.target.matches('[data-starting-set-option]')) this.requestStartingSet(event.target.value);
        });
        this.addEventListener('click', (event) => {
          const action = event.target.closest('[data-number-action]');
          if (action) this.changeNumber(action.dataset.number, action.dataset.numberAction);
          if (event.target.closest('[data-add-number-button]')) this.addManualNumber();
          if (event.target.closest('[data-generate-range]')) this.generateRange();
          if (event.target.closest('[data-replace-confirm]')) this.confirmStartingSet();
          if (event.target.closest('[data-replace-cancel]')) this.cancelStartingSet();
          if (event.target.closest('[data-editor-toggle]')) this.toggleNumberEditor();
        });
        this.form.addEventListener('submit', (event) => {
          if (!this.validateForPurchase()) event.preventDefault();
        });
      }

      get selectedStyle() { return this.querySelector('[data-style-option]:checked')?.value || ''; }
      get totalCount() { return [...this.numbers.values()].reduce((total, quantity) => total + quantity, 0); }
      get collectionSignature() { return this.sortedEntries().map(([number, quantity]) => `${number}:${quantity}`).join('|'); }
      get isPristine() { return this.collectionSignature === this.pristineSignature; }
      get purchaseState() {
        const errors = [];
        if (!this.totalCount) errors.push(this.dataset.emptyError);
        if (this.totalCount > this.maxStickers) errors.push(this.dataset.limitError);
        if (!this.optionMappingValid) errors.push(this.dataset.configurationError);
        else if (!this.currentVariant || !this.currentVariant.available) errors.push(this.dataset.unavailableError);

        return {
          errors,
          ready: errors.length === 0,
          variant: this.currentVariant
        };
      }

      normalizeNumber(raw) {
        const text = String(raw).trim();
        if (!/^\d+(?:\.\d)?$/.test(text)) return null;
        const number = Number(text);
        if (!Number.isFinite(number) || number <= 0 || number > 999) return null;
        return Number.isInteger(number) ? String(number) : number.toFixed(1).replace(/\.0$/, '');
      }

      sortedEntries() { return [...this.numbers.entries()].sort((a, b) => Number(a[0]) - Number(b[0])); }

      entriesForStartingSet(value) {
        if (value === 'Start From Scratch') return [];
        const end = Number(value.split('–')[1]);
        const entries = [];
        for (let number = 5; number <= end; number += 5) entries.push([String(number), 1]);
        return entries;
      }

      applyStartingSet(value) {
        this.startingSet = value;
        this.numbers = new Map(this.entriesForStartingSet(value));
        this.pristineSignature = this.collectionSignature;
        this.editorExpanded = value === 'Start From Scratch';
        this.querySelector('[data-starting-set-property]').value = value;
        const input = [...this.querySelectorAll('[data-starting-set-option]')].find((item) => item.value === value);
        if (input) input.checked = true;
        this.hideReplacement();
        this.render();
      }

      requestStartingSet(value) {
        if (value === this.startingSet) return;
        if (this.isPristine) {
          this.applyStartingSet(value);
          return;
        }
        this.pendingStartingSet = value;
        const current = [...this.querySelectorAll('[data-starting-set-option]')].find((item) => item.value === this.startingSet);
        if (current) current.checked = true;
        const confirmation = this.querySelector('[data-replace-confirmation]');
        this.querySelector('[data-replace-message]').textContent = this.dataset.replacePrompt.replace('[set]', value);
        confirmation.hidden = false;
        confirmation.querySelector('[data-replace-cancel]').focus();
      }

      confirmStartingSet() { if (this.pendingStartingSet) this.applyStartingSet(this.pendingStartingSet); }
      cancelStartingSet() { this.hideReplacement(); }
      hideReplacement() {
        this.pendingStartingSet = null;
        const confirmation = this.querySelector('[data-replace-confirmation]');
        confirmation.hidden = true;
      }

      changeNumber(number, action) {
        const quantity = this.numbers.get(number) || 0;
        if (action === 'increase') {
          if (quantity >= 50 || this.totalCount >= this.maxStickers) return this.showLimit();
          this.numbers.set(number, quantity + 1);
        } else if (action === 'decrease') {
          if (quantity <= 1) this.numbers.delete(number);
          else this.numbers.set(number, quantity - 1);
        } else if (action === 'remove') {
          this.numbers.delete(number);
        }
        this.render();
      }

      addManualNumber() {
        const numberInput = this.querySelector('[data-add-number]');
        const quantityInput = this.querySelector('[data-add-quantity]');
        const error = this.querySelector('[data-add-error]');
        const number = this.normalizeNumber(numberInput.value);
        const quantity = Number(quantityInput.value);
        error.hidden = true;
        if (!number) return this.showFieldError(error, 'Enter a number greater than 0 and no more than 999, using at most one decimal place.');
        if (!Number.isInteger(quantity) || quantity < 1 || quantity > 50) return this.showFieldError(error, 'Enter a whole-number quantity from 1 to 50.');
        if (this.totalCount + quantity > this.maxStickers) return this.showLimit();
        this.numbers.set(number, (this.numbers.get(number) || 0) + quantity);
        numberInput.value = '';
        quantityInput.value = '1';
        this.render();
        numberInput.focus();
      }

      generateRange() {
        const error = this.querySelector('[data-range-error]');
        const start = this.normalizeNumber(this.querySelector('[data-range-start]').value);
        const end = this.normalizeNumber(this.querySelector('[data-range-end]').value);
        const increment = this.normalizeNumber(this.querySelector('[data-range-increment]').value);
        const quantity = Number(this.querySelector('[data-range-quantity]').value);
        error.hidden = true;
        if (!start || !end || !increment || Number(end) < Number(start)) return this.showFieldError(error, 'Enter a valid start, end, and positive increment. The end must not be less than the start.');
        if (!Number.isInteger(quantity) || quantity < 1 || quantity > 50) return this.showFieldError(error, 'Enter a whole-number quantity from 1 to 50.');
        const startScaled = Math.round(Number(start) * 10);
        const endScaled = Math.round(Number(end) * 10);
        const incrementScaled = Math.round(Number(increment) * 10);
        const generated = [];
        for (let value = startScaled; value <= endScaled; value += incrementScaled) {
          generated.push(this.normalizeNumber(String(value / 10)));
          if (generated.length > 1000) break;
        }
        if (!generated.length) return this.showFieldError(error, 'This range did not generate any numbers.');
        if (this.totalCount + generated.length * quantity > this.maxStickers) return this.showLimit();
        generated.forEach((number) => this.numbers.set(number, (this.numbers.get(number) || 0) + quantity));
        this.render();
      }

      showFieldError(element, message) { element.textContent = message; element.hidden = false; }
      showLimit() { this.limitMessage.hidden = false; this.limitMessage.focus?.(); }

      toggleNumberEditor() {
        this.editorExpanded = !this.editorExpanded;
        this.renderDisclosure();
        if (this.editorExpanded) this.numberEditorHeading.focus();
        else this.editorToggle.focus();
      }

      render() {
        this.limitMessage.hidden = true;
        this.renderNumberList();
        this.renderDisclosure();
        this.resolveVariant();
        this.updateProperties();
        this.updateArtwork();
        this.renderSummary();
        this.updatePurchaseState();
      }

      renderNumberList() {
        const entries = this.sortedEntries();
        this.emptyState.hidden = entries.length > 0;
        this.numberList.replaceChildren(...entries.map(([number, quantity]) => {
          const row = document.createElement('div');
          row.className = 'dumbbell-rack-configurator__number-row';
          const value = document.createElement('span');
          value.className = 'dumbbell-rack-configurator__number-value';
          value.textContent = number;
          const stepper = document.createElement('div');
          stepper.className = 'dumbbell-rack-configurator__stepper';
          stepper.setAttribute('aria-label', `Quantity for ${number}`);
          stepper.append(this.actionButton(number, 'decrease', '−', `Decrease quantity for ${number}`));
          const output = document.createElement('output');
          output.value = String(quantity);
          output.textContent = String(quantity);
          output.setAttribute('aria-label', `${quantity} stickers`);
          stepper.append(output, this.actionButton(number, 'increase', '+', `Increase quantity for ${number}`));
          const remove = this.actionButton(number, 'remove', 'Remove', `Remove ${number}`);
          remove.className = 'dumbbell-rack-configurator__remove';
          row.append(value, stepper, remove);
          return row;
        }));
      }

      renderDisclosure() {
        const fromScratch = this.startingSet === 'Start From Scratch';
        this.setOverview.hidden = fromScratch;
        this.numberEditor.hidden = !this.editorExpanded;
        this.editorToggle.setAttribute('aria-expanded', String(this.editorExpanded));
        this.editorToggle.textContent = this.editorExpanded ? 'Hide sticker set' : 'Modify sticker set';
        if (fromScratch) return;

        const entries = this.sortedEntries();
        const customized = !this.isPristine;
        this.querySelector('[data-set-overview-title]').textContent = `${this.startingSet} set`;
        this.querySelector('[data-set-overview-detail]').textContent = customized ? `${this.totalCount} stickers` : `${this.totalCount} stickers · 5 lb increments`;
        this.querySelector('[data-set-customized]').hidden = !customized;
        const values = entries.map(([number]) => number);
        const preview = values.length > 5 ? `${values.slice(0, 4).join(', ')} ... ${values[values.length - 1]}` : values.join(', ');
        this.querySelector('[data-set-overview-includes]').textContent = preview ? `Includes: ${preview}` : 'No numbers selected';
      }

      actionButton(number, action, label, ariaLabel) {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.number = number;
        button.dataset.numberAction = action;
        button.textContent = label;
        button.setAttribute('aria-label', ariaLabel);
        return button;
      }

      resolveVariant() {
        this.currentVariant = null;
        this.variantInput.value = '';
        if (!this.optionMappingValid || this.totalCount < 1 || this.totalCount > this.maxStickers) return;
        const tier = this.totalCount <= 10 ? this.dataset.upToTenValue : String(this.totalCount);
        const selections = [];
        selections[this.stylePosition - 1] = this.selectedStyle;
        selections[this.countPosition - 1] = tier;
        this.currentVariant = this.product.variants.find((variant) => variant.options.every((value, index) => value === selections[index])) || null;
        if (this.currentVariant) {
          this.variantInput.value = this.currentVariant.id;
          this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          this.form.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { formId: this.form.id, variant: this.currentVariant } }));
          const url = new URL(window.location.href);
          url.searchParams.set('variant', this.currentVariant.id);
          window.history.replaceState({}, '', url);
        }
      }

      updateProperties() {
        const serialized = this.sortedEntries().map(([number, quantity]) => `${number}×${quantity}`).join(', ');
        this.querySelector('[data-starting-set-property]').value = this.startingSet;
        this.querySelector('[data-rack-numbers-property]').value = serialized;
        this.querySelector('[data-total-stickers-property]').value = this.totalCount ? String(this.totalCount) : '';
      }

      updateArtwork() {
        const enabled = this.selectedStyle === this.dataset.customStyleValue;
        this.artworkSection.hidden = !enabled;
        this.artworkUploadTarget.querySelectorAll('input, select, textarea, button').forEach((field) => {
          if (!enabled && !field.disabled) {
            field.disabled = true;
            field.dataset.rackArtworkDisabled = 'true';
          } else if (enabled && field.dataset.rackArtworkDisabled === 'true') {
            field.disabled = false;
            delete field.dataset.rackArtworkDisabled;
          }
          field.required = false;
          field.removeAttribute('aria-required');
        });
      }

      relocateUploadKit() {
        const uploader = this.purchaseActions.querySelector(':scope > .uploadkit.uploadkit-injected');
        if (uploader) this.artworkUploadTarget.append(uploader);
        this.updateArtwork();
      }

      renderSummary() {
        const styleInput = this.querySelector('[data-style-option]:checked');
        const styleLabel = styleInput ? this.querySelector(`label[for="${styleInput.id}"]`)?.textContent.trim() : '';
        const price = this.currentVariant ? this.formatMoney(this.currentVariant.price) : '—';
        this.querySelector('[data-total-count]').textContent = String(this.totalCount);
        this.querySelector('[data-total-price]').textContent = price;
        this.querySelector('[data-summary-design]').textContent = styleLabel;
        this.querySelector('[data-summary-starting-set]').textContent = this.startingSet;
        this.querySelector('[data-summary-count]').textContent = String(this.totalCount);
        this.querySelector('[data-summary-price]').textContent = price;
        const serialized = this.sortedEntries().map(([number, quantity]) => `${number}×${quantity}`).join(', ');
        this.querySelector('[data-summary-numbers]').textContent = serialized ? `Rack numbers: ${serialized}` : '';
      }

      updatePurchaseState() {
        const state = this.purchaseState;
        this.dataset.purchaseReady = String(state.ready);
        this.submitButton.disabled = !state.ready;
        this.acceleratedCheckout.hidden = !state.ready;
        if (!this.optionMappingValid) this.pricingStatus.textContent = this.dataset.configurationError;
        else if (!state.variant || !state.variant.available) this.pricingStatus.textContent = this.dataset.unavailableError;
        else this.pricingStatus.textContent = '';

        this.renderValidation(state.errors, false);
      }

      validateForPurchase() {
        const state = this.purchaseState;
        this.renderValidation(state.errors, !state.ready);
        return state.ready;
      }

      renderValidation(errors, focus) {
        if (!errors.length) {
          this.validation.hidden = true;
          this.validation.querySelector('ul').replaceChildren();
          return;
        }
        const list = this.validation.querySelector('ul');
        list.replaceChildren(...errors.map((message) => {
          const item = document.createElement('li');
          item.textContent = message;
          return item;
        }));
        this.validation.hidden = false;
        if (focus) this.validation.focus();
      }

      formatMoney(amount) {
        return new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currencyCode }).format(amount / 100);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticker-configurator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sticker-configurator')) {
    customElements.define('sticker-configurator', class extends HTMLElement {
      connectedCallback() {
        this.product = JSON.parse(this.querySelector('[data-product-json]').textContent);
        this.form = document.getElementById(this.dataset.formId);
        this.variantInput = this.querySelector('[data-variant-id]');
        this.quantityList = this.querySelector('[data-quantity-list]');
        this.summary = this.querySelector('[data-configurator-summary]');
        this.summaryList = this.querySelector('[data-summary-list]');
        this.summaryCompact = this.querySelector('[data-summary-compact]');
        this.summarySets = this.querySelector('[data-summary-sets]');
        this.summaryStickerCountRow = this.querySelector('[data-summary-sticker-count-row]');
        this.summaryStickerCount = this.querySelector('[data-summary-sticker-count]');
        this.summaryTotal = this.querySelector('[data-summary-total]');
        this.summaryUnit = this.querySelector('[data-summary-unit]');
        this.summaryUnitValue = this.querySelector('[data-summary-unit-value]');
        this.submitButton = this.querySelector('[data-configurator-submit]');
        this.validation = this.querySelector('[data-configurator-validation]');
        this.errorList = this.querySelector('[data-configurator-errors]');
        this.setQuantityInput = this.querySelector('[data-set-quantity]');
        this.sizePosition = Number(this.dataset.sizePosition);
        this.finishPosition = Number(this.dataset.finishPosition);
        this.quantityPosition = Number(this.dataset.quantityPosition);
        this.optionMappingValid = this.dataset.optionMappingValid === 'true';
        const initialVariant = this.product.variants.find((variant) => String(variant.id) === this.dataset.selectedVariantId);
        this.selectedQuantity = initialVariant?.options?.[this.quantityPosition - 1] || null;
        this.currentVariant = initialVariant || null;

        this.optionInputs = Array.from(this.querySelectorAll('[data-configurator-option]'));
        this.productionPropertyInputs = Array.from(this.querySelectorAll('[data-production-property]'));
        this.optionInputs.forEach((input) => input.addEventListener('change', () => this.refresh()));
        this.productionPropertyInputs.forEach((input) => input.addEventListener('change', () => {
          this.renderSummary(this.selections, this.currentVariant);
        }));
        this.quantityList?.addEventListener('change', (event) => {
          if (!event.target.matches('[data-quantity-input]')) return;
          this.selectedQuantity = event.target.value;
          this.refresh();
        });
        this.setQuantityInput?.addEventListener('input', () => {
          this.renderSummary(this.selections, this.currentVariant);
        });
        this.setQuantityInput?.addEventListener('change', () => {
          this.setQuantityInput.value = String(this.setCount);
          this.renderSummary(this.selections, this.currentVariant);
        });

        this.form?.addEventListener('submit', (event) => this.validateSubmission(event), { capture: true });
        this.form?.addEventListener('formdata', (event) => {
          Array.from(event.formData.keys()).forEach((key) => {
            if (key.startsWith('sticker-selection-') || key.startsWith('sticker-quantity-')) {
              event.formData.delete(key);
            }
          });
        });
        this.form?.addEventListener('cart:error', (event) => this.showErrors([event.detail.error]));
        this.setupModules();
        this.refresh();
      }

      get selections() {
        const values = {};
        this.optionInputs.filter((input) => input.checked).forEach((input) => {
          values[Number(input.dataset.optionPosition)] = input.value;
        });
        if (this.selectedQuantity) values[this.quantityPosition] = this.selectedQuantity;
        return values;
      }

      get setCount() {
        return Math.max(1, Number.parseInt(this.setQuantityInput?.value, 10) || 1);
      }

      variantsForSelections(selections, ignoredPosition = 0) {
        return this.product.variants.filter((variant) => Object.entries(selections).every(([position, value]) => {
          const numericPosition = Number(position);
          return numericPosition === ignoredPosition || variant.options[numericPosition - 1] === value;
        }));
      }

      refresh() {
        const baseSelections = this.selections;
        delete baseSelections[this.quantityPosition];
        this.refreshOptionAvailability(baseSelections);
        const quantityVariants = this.variantsForSelections(baseSelections);
        this.renderQuantityChoices(quantityVariants);

        const completeSelections = { ...baseSelections };
        if (this.selectedQuantity) completeSelections[this.quantityPosition] = this.selectedQuantity;

        const resolvedVariant = this.variantsForSelections(completeSelections).find((variant) => variant.available) || null;
        this.commitVariant(resolvedVariant);
        this.renderSummary(completeSelections, resolvedVariant);
        this.clearErrors();
      }

      refreshOptionAvailability(selections) {
        this.optionInputs.forEach((input) => {
          const position = Number(input.dataset.optionPosition);
          const proposedSelections = { ...selections, [position]: input.value };
          const available = this.variantsForSelections(proposedSelections, this.quantityPosition).some((variant) => variant.available);
          input.disabled = !available;
        });
      }

      renderQuantityChoices(variants) {
        if (!this.quantityList) return;

        const choices = [];
        const seen = new Set();
        variants.forEach((variant) => {
          const value = variant.options[this.quantityPosition - 1];
          if (seen.has(value)) return;
          seen.add(value);
          choices.push({ value, variant });
        });

        if (this.selectedQuantity && !choices.some((choice) => choice.value === this.selectedQuantity && choice.variant.available)) {
          this.selectedQuantity = null;
        }

        this.quantityList.replaceChildren(...choices.map((choice, index) => {
          const units = this.parseUnits(choice.value);
          const wrapper = document.createElement('div');
          const input = document.createElement('input');
          const label = document.createElement('label');
          const id = `sticker-quantity-${this.dataset.sectionId}-${index}`;

          input.className = 'sr-only sticker-configurator__quantity-input';
          input.type = 'radio';
          input.id = id;
          input.name = `sticker-quantity-${this.dataset.sectionId}`;
          input.value = choice.value;
          input.dataset.quantityInput = '';
          input.checked = choice.value === this.selectedQuantity;
          input.disabled = !choice.variant.available;

          label.className = 'sticker-configurator__quantity-row';
          label.htmlFor = id;

          const quantity = document.createElement('span');
          quantity.className = 'bold';
          quantity.textContent = choice.value;

          const total = document.createElement('span');
          total.className = 'bold';
          total.textContent = choice.variant.available ? this.formatMoney(choice.variant.price) : this.dataset.unavailableLabel;

          const unit = document.createElement('span');
          unit.className = 'text-sm text-subdued';
          unit.textContent = choice.variant.available && units ? `${this.formatMoney(choice.variant.price / units)} ${this.dataset.eachLabel}` : '—';

          label.append(quantity, total, unit);
          wrapper.append(input, label);
          return wrapper;
        }));
      }

      commitVariant(variant) {
        const previousVariant = this.currentVariant;
        this.currentVariant = variant;
        this.variantInput.value = variant?.id || '';
        this.submitButton.disabled = !variant || !this.optionMappingValid;

        if (variant) {
          this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          this.form.dispatchEvent(new CustomEvent('variant:change', {
            bubbles: true,
            detail: { formId: this.form.id, variant, previousVariant }
          }));

          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({ path: url.toString() }, '', url.toString());
        }
      }

      renderSummary(selections, variant) {
        const rows = [];
        this.productionPropertyInputs.filter((input) => input.checked).forEach((input) => {
          rows.push({ label: input.dataset.summaryLabel, value: input.dataset.summaryValue || input.value });
        });

        [this.finishPosition, this.sizePosition, this.quantityPosition].forEach((position) => {
          if (!position) return;
          let value = selections[position];
          if (position === this.sizePosition) value = this.formatSize(value);
          if (value) rows.push({ label: this.product.options[position - 1], value });
        });

        this.summaryList.replaceChildren(...rows.map((row) => {
          const container = document.createElement('div');
          const term = document.createElement('dt');
          const description = document.createElement('dd');
          term.className = 'text-subdued';
          term.textContent = row.label;
          description.textContent = row.value;
          container.append(term, description);
          return container;
        }));
        this.summaryCompact.textContent = rows.map((row) => row.value).join(' • ');

        const units = this.parseUnits(this.selectedQuantity);
        const sets = this.setCount;
        const setLabel = sets === 1 ? this.dataset.setSingularLabel : this.dataset.setPluralLabel;
        const unitsStickerLabel = units === 1 ? this.dataset.stickerSingularLabel : this.dataset.stickerPluralLabel;
        const stickerCount = units * sets;
        const stickerLabel = stickerCount === 1 ? this.dataset.stickerSingularLabel : this.dataset.stickerPluralLabel;

        this.summarySets.hidden = !units;
        this.summaryStickerCountRow.hidden = !units;
        if (units) {
          this.summarySets.textContent = `${this.formatNumber(units)} ${unitsStickerLabel} ${this.dataset.perSetLabel} × ${this.formatNumber(sets)} ${setLabel}`;
          this.summaryStickerCount.textContent = `${this.formatNumber(stickerCount)} ${stickerLabel}`;
        }

        if (!variant) {
          this.summaryTotal.textContent = '—';
          this.summaryUnit.hidden = true;
          return;
        }

        this.summaryTotal.textContent = this.formatMoney(variant.price * sets);
        this.summaryUnit.hidden = !units;
        if (units) this.summaryUnitValue.textContent = this.formatMoney(variant.price / units);
      }

      validateSubmission(event) {
        const errors = [];
        if (!this.optionMappingValid) errors.push(this.dataset.unavailableError);
        if (!this.selectedQuantity) errors.push(this.dataset.selectQuantityError);
        if (!this.currentVariant || !this.currentVariant.available) errors.push(this.dataset.unavailableError);

        const invalidFields = Array.from(this.form.elements).filter((field) => field.willValidate && !field.checkValidity());
        invalidFields.forEach((field) => errors.push(field.dataset.validationMessage || field.validationMessage));

        if (errors.length) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.showErrors(errors);
          return;
        }
      }

      showErrors(errors) {
        this.errorList.replaceChildren(...errors.map((message) => {
          const item = document.createElement('li');
          item.textContent = message;
          return item;
        }));
        this.validation.hidden = false;
        this.validation.focus();
      }

      clearErrors() {
        this.validation.hidden = true;
        this.errorList.replaceChildren();
      }

      setupModules() {
        this.querySelectorAll('[data-configurator-module="qr"]').forEach((module) => {
          const positionInputs = Array.from(module.querySelectorAll('input[type="radio"]'));
          const urlInput = this.querySelector('[data-qr-url]');
          if (!urlInput) return;

          const updateRequirement = () => {
            const selectedPosition = positionInputs.find((input) => input.checked)?.value || '';
            const requiresUrl = module.dataset.urlRequired === 'true' && selectedPosition !== module.dataset.noQrValue;
            urlInput.required = requiresUrl;
            urlInput.closest('[data-qr-destination]')?.toggleAttribute('hidden', !requiresUrl);
            if (!requiresUrl) urlInput.value = '';
          };

          positionInputs.forEach((input) => input.addEventListener('change', updateRequirement));
          updateRequirement();
        });
      }

      parseUnits(value) {
        if (!value) return 0;
        const match = String(value).replaceAll(',', '').match(/\d+(?:\.\d+)?/);
        return match ? Number(match[0]) : 0;
      }

      formatSize(value) {
        return value ? String(value).replace(/\s+Inches?$/i, '″') : value;
      }

      formatMoney(amount) {
        return new Intl.NumberFormat(this.dataset.locale, {
          style: 'currency',
          currency: this.dataset.currencyCode
        }).format(amount / 100);
      }

      formatNumber(value) {
        return new Intl.NumberFormat(this.dataset.locale).format(value);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weight-stack-configurator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('weight-stack-configurator')) {
    customElements.define('weight-stack-configurator', class extends HTMLElement {
      connectedCallback() {
        this.product = JSON.parse(this.querySelector('[data-product-json]').textContent);
        this.form = document.getElementById(this.dataset.formId);
        this.variantInput = this.querySelector('[data-variant-id]');
        this.stylePosition = Number(this.dataset.stylePosition);
        this.machinePosition = Number(this.dataset.machinePosition);
        this.styleInput = this.querySelector('[data-variant-option]');
        this.machineInput = this.querySelector('[data-machine-option]');
        this.customFlow = this.querySelector('[data-custom-flow]');
        this.customFields = Array.from(this.querySelectorAll('[data-custom-field]'));
        this.machineDetailFields = Array.from(this.querySelectorAll('[data-machine-detail-field]'));
        this.measurementStatusInputs = Array.from(this.querySelectorAll('[data-measurement-status]'));
        this.measurementDetails = Array.from(this.querySelectorAll('[data-measurement-details]'));
        this.measurementUnitInputs = Array.from(this.querySelectorAll('[data-measurement-unit-option]'));
        this.dimensionFields = Array.from(this.querySelectorAll('[data-dimension-field]'));
        this.measurementValues = new WeakMap();
        this.measurementUnit = this.selectedMeasurementUnit;
        this.plateHeightInput = this.querySelector('[data-plate-height]');
        this.groups = Array.from(this.querySelectorAll('[data-plate-group]'));
        this.layoutInputs = Array.from(this.querySelectorAll('[data-layout-option]'));
        this.offsetInputs = Array.from(this.querySelectorAll('[data-offset-option]'));
        this.offsetFields = Array.from(this.querySelectorAll('[data-offset-field]'));
        this.offsetDiagram = this.querySelector('[data-offset-diagram]');
        this.holeLayout = this.querySelector('[data-hole-layout]');
        this.submitButton = this.querySelector('[data-configurator-submit]');
        this.validation = this.querySelector('[data-configurator-validation]');
        this.errorList = this.querySelector('[data-configurator-errors]');
        this.summaryList = this.querySelector('[data-summary-list]');
        this.summaryTotal = this.querySelector('[data-summary-total]');
        this.previewPlates = this.querySelector('[data-preview-plates]');
        this.totalPlates = this.querySelector('[data-total-plates]');
        this.stackPhotoCopy = this.querySelector('[data-stack-photo-copy]');
        this.artworkSection = this.querySelector('[data-artwork-section]');
        this.artworkUploadTarget = this.querySelector('[data-artwork-upload-target]');
        this.purchaseActions = this.querySelector('.weight-stack-configurator__purchase-actions');
        this.customDisclaimer = this.querySelector('[data-custom-disclaimer]');
        this.measurementsLaterCallout = this.querySelector('[data-measurements-later]');
        this.copyChecklistButton = this.querySelector('[data-copy-measurement-checklist]');
        this.copyChecklistStatus = this.querySelector('[data-copy-measurement-status]');
        this.optionMappingValid = this.dataset.optionMappingValid === 'true';
        this.validationAttempted = false;

        this.styleInput?.addEventListener('change', () => this.refresh());
        this.machineInput?.addEventListener('change', () => this.refresh());
        this.layoutInputs.forEach((input) => input.addEventListener('change', () => this.updateCustomFlow()));
        this.offsetInputs.forEach((input) => input.addEventListener('change', () => this.updateCustomFlow()));
        this.measurementStatusInputs.forEach((input) => input.addEventListener('change', () => this.updateCustomFlow()));
        this.measurementUnitInputs.forEach((input) => input.addEventListener('change', () => this.changeMeasurementUnit()));
        this.dimensionFields.forEach((field) => field.addEventListener('input', () => this.rememberMeasurement(field)));
        this.querySelectorAll('[data-numbering-toggle]').forEach((input) => input.addEventListener('change', () => this.updateCustomFlow()));
        this.form?.addEventListener('input', () => this.updateCustomFlow());
        this.form?.addEventListener('change', () => this.updateCustomFlow());
        this.form?.addEventListener('submit', (event) => this.validateSubmission(event), { capture: true });
        this.form?.addEventListener('cart:error', (event) => this.showErrors([event.detail.error]));
        this.copyChecklistButton?.addEventListener('click', () => this.copyMeasurementChecklist());
        this.uploadKitObserver = new MutationObserver(() => {
          this.relocateUploadKit();
          this.updateArtworkState();
        });
        this.uploadKitObserver.observe(this.form, { childList: true, subtree: true });

        this.updateMeasurementLimits();
        this.relocateUploadKit();
        this.refresh();
      }

      disconnectedCallback() {
        this.uploadKitObserver?.disconnect();
      }

      get selectedStyle() {
        return this.styleInput?.value || '';
      }

      get selectedMachine() {
        return this.machineInput?.value || '';
      }

      get isCustomMachine() {
        return this.selectedMachine === this.dataset.otherValue;
      }

      get isCustomDesign() {
        return this.selectedStyle === this.dataset.customDesignValue;
      }

      get selectedMeasurementUnit() {
        return this.measurementUnitInputs.find((input) => input.checked)?.value || 'Inches';
      }

      get selectedMeasurementStatus() {
        return this.measurementStatusInputs.find((input) => input.checked)?.value || 'Provided with order';
      }

      get measurementsDeferred() {
        return this.selectedMeasurementStatus === 'Will email later';
      }

      get collectingMeasurements() {
        return this.isCustomMachine && !this.measurementsDeferred;
      }

      get selectedGroupCount() {
        const value = this.layoutInputs.find((input) => input.checked)?.value || 'One Size';
        if (value.includes('Three')) return 3;
        if (value.includes('Two')) return 2;
        return 1;
      }

      refresh() {
        const selections = [];
        selections[this.stylePosition - 1] = this.selectedStyle;
        selections[this.machinePosition - 1] = this.selectedMachine;
        const variant = this.product.variants.find((candidate) => candidate.options.every((value, index) => value === selections[index]));
        this.currentVariant = variant || null;
        this.variantInput.value = variant?.id || '';

        Array.from(this.styleInput?.options || []).forEach((option) => {
          option.disabled = !this.product.variants.some((candidate) => candidate.available && candidate.options[this.stylePosition - 1] === option.value && candidate.options[this.machinePosition - 1] === this.selectedMachine);
        });

        if (variant) {
          this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          this.form.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { formId: this.form.id, variant } }));
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({ path: url.toString() }, '', url.toString());
        }

        this.updateCustomFlow();
      }

      updateCustomFlow() {
        this.customFlow.hidden = !this.isCustomMachine;
        this.measurementStatusInputs.forEach((field) => field.disabled = !this.isCustomMachine);
        this.machineDetailFields.forEach((field) => {
          field.disabled = !this.isCustomMachine;
          field.required = false;
        });
        this.measurementDetails.forEach((element) => element.hidden = !this.collectingMeasurements);
        this.measurementsLaterCallout.hidden = !this.isCustomMachine || !this.measurementsDeferred;
        this.customFields.forEach((field) => {
          field.disabled = !this.isCustomMachine;
          field.required = this.collectingMeasurements;
        });
        if (!this.isCustomMachine) {
          this.plateHeightInput.value = '';
          this.measurementValues.delete(this.plateHeightInput);
        }

        this.groups.forEach((group, index) => this.updateGroup(group, this.isCustomMachine && index < this.selectedGroupCount, this.collectingMeasurements));

        const hasOffset = this.offsetInputs.find((input) => input.checked)?.value === 'Yes';
        const offsetDetails = this.querySelector('[data-offset-details]');
        offsetDetails.hidden = !this.collectingMeasurements || !hasOffset;
        this.offsetDiagram.hidden = !this.collectingMeasurements || !hasOffset;
        this.holeLayout.dataset.hasOffset = String(this.collectingMeasurements && hasOffset);
        this.offsetFields.forEach((field) => {
          field.disabled = !this.isCustomMachine || !hasOffset;
          field.required = this.collectingMeasurements && hasOffset;
        });

        this.stackPhotoCopy.hidden = !this.isCustomMachine;
        this.updateArtworkState();
        this.customDisclaimer.hidden = !this.collectingMeasurements;
        this.syncMeasurements();
        this.renderPreview();
        this.renderSummary();
        this.updateSubmitState();
      }

      updateGroup(group, active, requireMeasurements) {
        group.hidden = !active;
        const customNumbering = group.querySelector('[data-numbering-toggle]').checked;
        group.querySelectorAll('[data-group-field]').forEach((field) => {
          const isStandard = Boolean(field.closest('[data-standard-numbering]'));
          const isCustom = field.matches('[data-preview-field="labels"]');
          const applies = active && (!isStandard || !customNumbering) && (!isCustom || customNumbering);
          field.disabled = !applies;
          field.required = requireMeasurements && applies;
        });
        group.querySelectorAll('[data-standard-numbering]').forEach((container) => container.hidden = customNumbering);
        group.querySelector('[data-custom-numbering]').hidden = !customNumbering;
        const labels = group.querySelector('[data-preview-field="labels"]');
        const count = Number.parseInt(group.querySelector('[data-preview-field="count"]').value, 10) || 0;
        const labelCount = labels.value.split(/[\n,]+/).map((value) => value.trim()).filter(Boolean).length;
        labels.setCustomValidity(requireMeasurements && active && customNumbering && labels.value && labelCount !== count ? this.dataset.numberingError : '');
      }

      relocateUploadKit() {
        const injectedUploader = this.purchaseActions.querySelector(':scope > .uploadkit.uploadkit-injected');
        if (injectedUploader) this.artworkUploadTarget.append(injectedUploader);
      }

      updateArtworkState() {
        const artworkEnabled = this.isCustomDesign;
        this.artworkSection.hidden = !artworkEnabled;
        this.artworkUploadTarget.querySelectorAll('input, select, textarea, button').forEach((field) => {
          field.required = false;
          field.removeAttribute('aria-required');
          if (!artworkEnabled && !field.disabled) {
            field.disabled = true;
            field.dataset.configuratorArtworkDisabled = 'true';
          } else if (artworkEnabled && field.dataset.configuratorArtworkDisabled === 'true') {
            field.disabled = false;
            delete field.dataset.configuratorArtworkDisabled;
          }
        });
      }

      renderPreview() {
        const plates = [];
        const enteredPlateHeight = Number(this.plateHeightInput.value) || 0;
        this.groups.filter((group) => !group.hidden).forEach((group, groupIndex) => {
          const width = Number(group.querySelector('[data-preview-field="width"]').value) || 1;
          const count = Math.min(40, Math.max(0, Number.parseInt(group.querySelector('[data-preview-field="count"]').value, 10) || 0));
          const customNumbering = group.querySelector('[data-numbering-toggle]').checked;
          const labels = group.querySelector('[data-preview-field="labels"]').value.split(/[\n,]+/).map((value) => value.trim()).filter(Boolean);
          const start = Number(group.querySelector('[data-preview-field="start"]').value) || 0;
          const increment = Number(group.querySelector('[data-preview-field="increment"]').value) || 0;
          for (let index = 0; index < count && plates.length < 60; index += 1) {
            plates.push({ groupIndex, width, label: customNumbering ? labels[index] || '—' : this.formatNumber(start + (index * increment)) });
          }
        });

        const maxWidth = Math.max(...plates.map((item) => item.width), 1);
        const naturalPlateHeight = Math.min(28, Math.max(10, (enteredPlateHeight / maxWidth) * 210 || 18));
        const verticalScale = Math.min(1, 450 / Math.max((naturalPlateHeight + 4) * plates.length, 1));
        const plateHeight = Math.max(7, naturalPlateHeight * verticalScale);
        const plateGap = Math.max(2, 4 * verticalScale);

        this.previewPlates.replaceChildren(...plates.map((plate, index) => {
          const group = document.createElementNS('http://www.w3.org/2000/svg', 'g');
          const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
          const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
          const width = 150 + ((plate.width / maxWidth) * 210);
          const x = (420 - width) / 2;
          const y = 20 + (index * (plateHeight + plateGap));
          rect.setAttribute('x', x);
          rect.setAttribute('y', y);
          rect.setAttribute('width', width);
          rect.setAttribute('height', plateHeight);
          rect.setAttribute('rx', 4);
          rect.setAttribute('fill', '#fff');
          rect.setAttribute('stroke', '#1a1a1a');
          rect.setAttribute('stroke-width', 2);
          text.setAttribute('x', 210);
          text.setAttribute('y', y + Math.max(7, (plateHeight / 2) + 4));
          text.setAttribute('text-anchor', 'middle');
          text.setAttribute('font-size', 11);
          text.textContent = plate.label;
          group.append(rect, text);
          return group;
        }));
        this.totalPlates.textContent = this.formatNumber(plates.length);
      }

      renderSummary() {
        const rows = [
          { label: 'Design', value: this.selectedStyle },
          { label: 'Machine', value: this.selectedMachine }
        ];

        if (this.isCustomMachine) {
          rows.push({ label: 'Measurement Status', value: this.selectedMeasurementStatus });
          this.machineDetailFields.forEach((field) => {
            if (field.value) rows.push({ label: field.dataset.summaryLabel, value: this.formatMeasurement(field) });
          });

          if (this.collectingMeasurements) {
            rows.push({ label: 'Measurement Unit', value: this.measurementUnit });
            this.querySelectorAll('[data-summary-label]:not([data-machine-detail-field]):not(:disabled)').forEach((field) => {
              if (field.value) rows.push({ label: field.dataset.summaryLabel, value: this.formatMeasurement(field) });
            });
            const layout = this.layoutInputs.find((input) => input.checked)?.value;
            if (layout) rows.push({ label: 'Stack Layout', value: layout });
            rows.push({ label: 'Total Plates', value: this.totalPlates.textContent });
            if (this.offsetInputs.find((input) => input.checked)?.value === 'Yes') {
              rows.push({ label: 'Offset Hole', value: this.querySelector('[data-offset-direction]:checked')?.value || '' });
            } else {
              rows.push({ label: 'Offset Hole', value: 'No' });
            }
          }
        }

        this.summaryList.replaceChildren(...rows.filter((row) => row.value).map((row) => {
          const container = document.createElement('div');
          const term = document.createElement('dt');
          const description = document.createElement('dd');
          term.className = 'text-subdued';
          term.textContent = row.label;
          description.textContent = row.value;
          container.append(term, description);
          return container;
        }));
        this.summaryTotal.textContent = this.currentVariant ? this.formatMoney(this.currentVariant.price) : '—';
      }

      formatMeasurement(field) {
        if (field.matches('[data-dimension-field]')) return `${field.value} ${this.measurementUnit === 'Millimeters' ? 'mm' : 'in'}`;
        return field.value;
      }

      rememberMeasurement(field) {
        if (!field.value) {
          this.measurementValues.delete(field);
          return;
        }
        const value = Number(field.value);
        if (Number.isFinite(value)) this.measurementValues.set(field, this.measurementUnit === 'Millimeters' ? value / 25.4 : value);
      }

      changeMeasurementUnit() {
        const nextUnit = this.selectedMeasurementUnit;
        this.dimensionFields.forEach((field) => {
          if (!this.measurementValues.has(field) && field.value) this.rememberMeasurement(field);
          const inches = this.measurementValues.get(field);
          if (Number.isFinite(inches)) field.value = this.formatMeasurementNumber(nextUnit === 'Millimeters' ? inches * 25.4 : inches);
        });
        this.measurementUnit = nextUnit;
        this.updateMeasurementLimits();
        this.updateCustomFlow();
      }

      updateMeasurementLimits() {
        const factor = this.measurementUnit === 'Millimeters' ? 25.4 : 1;
        this.dimensionFields.forEach((field) => {
          field.min = this.formatMeasurementNumber(Number(field.dataset.minInches) * factor);
          field.max = this.formatMeasurementNumber(Number(field.dataset.maxInches) * factor);
        });
        this.querySelectorAll('[data-measurement-unit]').forEach((unit) => unit.textContent = this.measurementUnit === 'Millimeters' ? 'mm' : 'in');
      }

      syncMeasurements() {
        this.dimensionFields.forEach((field) => {
          const property = field.parentElement.querySelector('[data-measurement-property]');
          property.disabled = field.disabled;
          property.value = field.value ? this.formatMeasurement(field) : '';
        });
      }

      formatMeasurementNumber(value) {
        return Number(value.toFixed(4)).toString();
      }

      updateSubmitState() {
        const validVariant = Boolean(this.currentVariant?.available && this.optionMappingValid);
        const invalidFields = this.invalidRequiredFields();
        const validFields = invalidFields.length === 0;
        this.submitButton.disabled = !validVariant;
        this.dataset.purchaseReady = String(validVariant && validFields);
        if (this.validationAttempted) {
          if (validVariant && validFields) {
            this.validationAttempted = false;
            this.clearErrors();
          } else {
            this.updateFieldErrors(invalidFields);
          }
        }
      }

      validateSubmission(event) {
        this.validationAttempted = true;
        const errors = [];
        if (!this.currentVariant?.available || !this.optionMappingValid) errors.push(this.dataset.unavailableError);
        const invalidFields = this.invalidRequiredFields();
        invalidFields.forEach((field) => errors.push(field.dataset.validationMessage || field.validationMessage || this.dataset.customError));

        this.groups.filter((group) => this.collectingMeasurements && !group.hidden && group.querySelector('[data-numbering-toggle]').checked).forEach((group) => {
          const count = Number.parseInt(group.querySelector('[data-preview-field="count"]').value, 10) || 0;
          const labels = group.querySelector('[data-preview-field="labels"]').value.split(/[\n,]+/).map((value) => value.trim()).filter(Boolean);
          if (labels.length !== count) errors.push(this.dataset.numberingError);
        });

        if (errors.length) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.showErrors([...new Set(errors)], invalidFields);
        } else {
          this.validationAttempted = false;
          this.clearErrors();
        }
      }

      invalidRequiredFields() {
        return Array.from(this.form.elements).filter((field) => field.required && field.willValidate && !field.checkValidity());
      }

      showErrors(errors, invalidFields = []) {
        this.errorList.replaceChildren(...errors.map((message) => {
          const item = document.createElement('li');
          item.textContent = message;
          return item;
        }));
        this.validation.hidden = false;
        this.updateFieldErrors(invalidFields);
        const firstInvalid = invalidFields[0];
        if (firstInvalid) {
          firstInvalid.focus({ preventScroll: true });
          firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          this.validation.focus();
        }
      }

      updateFieldErrors(invalidFields) {
        const invalidSet = new Set(invalidFields);
        this.form.querySelectorAll('[aria-invalid="true"]').forEach((field) => {
          if (!invalidSet.has(field)) this.clearFieldError(field);
        });

        invalidFields.forEach((field) => {
          if (!field.id) return;
          field.setAttribute('aria-invalid', 'true');
          const errorId = `${field.id}-error`;
          const describedBy = new Set((field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
          describedBy.add(errorId);
          field.setAttribute('aria-describedby', [...describedBy].join(' '));
          let error = this.querySelector(`#${CSS.escape(errorId)}`);
          if (!error) {
            error = document.createElement('p');
            error.id = errorId;
            error.className = 'weight-stack-configurator__field-error';
            field.closest('.weight-stack-configurator__field, fieldset')?.append(error);
          }
          error.textContent = field.dataset.validationMessage || field.validationMessage || this.dataset.customError;
        });
      }

      clearFieldError(field) {
        field.removeAttribute('aria-invalid');
        if (!field.id) return;
        const errorId = `${field.id}-error`;
        this.querySelector(`#${CSS.escape(errorId)}`)?.remove();
        const describedBy = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter((id) => id && id !== errorId);
        if (describedBy.length) field.setAttribute('aria-describedby', describedBy.join(' '));
        else field.removeAttribute('aria-describedby');
      }

      clearErrors() {
        this.validation.hidden = true;
        this.errorList.replaceChildren();
        this.form.querySelectorAll('[aria-invalid="true"]').forEach((field) => this.clearFieldError(field));
      }

      buildMeasurementChecklist() {
        const unit = this.measurementUnit === 'Millimeters' ? 'Millimeters' : 'Inches';
        const unitSuffix = unit === 'Millimeters' ? 'mm' : 'in';
        const make = this.machineDetailFields.find((field) => field.name === 'properties[Machine Make]')?.value.trim() || '';
        const model = this.machineDetailFields.find((field) => field.name === 'properties[Machine Model]')?.value.trim() || '';
        const dimensionValue = (field) => field?.value ? `${field.value} ${unitSuffix}` : '';
        const fieldValue = (field) => field?.value?.trim() || '';
        const lines = [
          'Plate Snacks — Weight Stack Measurements',
          '',
          'Email completed measurements to:',
          'hello@platesnacks.com',
          '',
          'CUSTOMER INFORMATION',
          '',
          'Name:',
          'Order Number:',
          '',
          'MACHINE INFORMATION',
          '',
          `Brand / Manufacturer (if known): ${make}`,
          `Model (if known): ${model}`,
          '',
          'MEASUREMENTS',
          '',
          `Measurement Unit: ${unit}`,
          `Individual Plate Height: ${dimensionValue(this.plateHeightInput)}`,
          `Number of Different Plate Widths: ${this.selectedGroupCount}`,
          ''
        ];

        this.groups.slice(0, this.selectedGroupCount).forEach((group, index) => {
          const customNumbering = group.querySelector('[data-numbering-toggle]').checked;
          lines.push(
            `Plate Group ${index + 1}`,
            `Plate Width: ${dimensionValue(group.querySelector('[data-preview-field="width"]'))}`,
            `Number of Plates: ${fieldValue(group.querySelector('[data-preview-field="count"]'))}`
          );
          if (customNumbering) {
            lines.push(`Plate Labels in Order: ${fieldValue(group.querySelector('[data-preview-field="labels"]'))}`);
          } else {
            lines.push(
              `Starting Weight / Number: ${fieldValue(group.querySelector('[data-preview-field="start"]'))}`,
              `Weight Increment: ${fieldValue(group.querySelector('[data-preview-field="increment"]'))}`
            );
          }
          lines.push('');
        });

        const centerHole = this.querySelector('#center-hole-' + CSS.escape(this.dataset.sectionId));
        const hasOffset = this.offsetInputs.find((input) => input.checked)?.value === 'Yes';
        lines.push(
          `Selector Hole Diameter: ${dimensionValue(centerHole)}`,
          `Offset Hole: ${hasOffset ? 'Yes' : 'No'}`
        );
        if (hasOffset) {
          lines.push(
            `Offset Hole Position: ${this.querySelector('[data-offset-direction]:checked')?.value || ''}`,
            `Hole Spacing (Center to Center): ${dimensionValue(this.querySelector('#center-distance-' + CSS.escape(this.dataset.sectionId)))}`
          );
        }

        const notes = this.querySelector('[data-character-input]')?.value.trim() || '';
        lines.push('', 'ADDITIONAL INFORMATION', '', `Notes: ${notes}`, '', 'Please attach a straight-on photo of the full weight stack if possible.');
        return lines.join('\n');
      }

      async copyMeasurementChecklist() {
        const checklist = this.buildMeasurementChecklist();
        let copied = false;
        try {
          if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(checklist);
            copied = true;
          }
        } catch (error) {
          copied = false;
        }

        if (!copied) {
          try {
            const copySource = document.createElement('textarea');
            copySource.value = checklist;
            copySource.setAttribute('readonly', '');
            copySource.style.position = 'fixed';
            copySource.style.opacity = '0';
            document.body.append(copySource);
            copySource.select();
            copied = document.execCommand('copy');
            copySource.remove();
          } catch (error) {
            copied = false;
          }
        }

        if (copied) {
          this.copyChecklistStatus.textContent = 'Checklist copied!';
        } else {
          this.copyChecklistStatus.textContent = 'Unable to copy automatically. Please copy the checklist manually.';
        }
      }

      formatMoney(amount) {
        return new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currencyCode }).format(amount / 100);
      }

      formatNumber(value) {
        return new Intl.NumberFormat(this.dataset.locale, { maximumFractionDigits: 2 }).format(value);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
